// Gtag integration script

const initializeGtag = () => {
    const a = document.createElement('script');
    a.async = true;
    a.src = 'https://www.googletagmanager.com/gtag/js?id=UA-125892782-3';
    const b = document.getElementsByTagName('script')[0];
    b.parentNode?.insertBefore(a, b);

    window.dataLayer = window.dataLayer || [];
    const gtag = (...args: unknown[]) => {
        window.dataLayer?.push(args);
    };
    gtag('js', new Date());
    gtag('config', 'UA-125892782-3');
};

export default initializeGtag;
